var FileWrapper = require('filewrapper');

//norefactor
var RESTRICTED_REASONS = {
    networks: 'You’ve exceeded the connection limit for free accounts. <b>Upgrade now</b> to connect to more servers',
    unverified: 'You can’t connect to external servers until you confirm your email address',
    passworded_servers: 'You can’t connect to passworded servers with free accounts. <b>Upgrade now</b>',
    slack_disallowed: 'You can’t connect to Slack workspaces with free accounts. <b>Upgrade now</b>'
};
var RESTRICTED_REASONS_SHORT = {
    networks: 'Network limit exceeded',
    unverified: 'Email verification required',
    passworded_servers: 'Passworded servers disallowed',
    slack_disallowed: 'Slack disallowed'
};

var RENDER_REASONS = {
    pool_lost: 'Connection pool failed',
    no_pool: 'No available connection pools',
    enetdown: 'Network down',
    etimedout: 'Timed out',
    timeout: 'Timed out',
    closed: 'Connection closed',
    enotconn: 'Connection unavailable',
    ehostunreach: 'Host unreachable',
    econnrefused: 'Connection refused',
    nxdomain: 'Invalid hostname',
    einval: 'Invalid hostname',
    ssl_certificate_error: 'SSL certificate error',
    ssl_error: 'SSL error',
    crash: 'Connection crashed'
};

var SSL_VERIFY_ERRORS = {
    bad_cert: {
        unknown_ca: 'Unknown certificate authority',
        selfsigned_peer: 'Self signed certificate',
        cert_expired: 'Certificate expired',
        invalid_issuer: 'Invalid certificate issuer',
        invalid_signature: 'Invalid certificate signature',
        name_not_permitted: 'Invalid certificate alternative hostname',
        missing_basic_constraint: 'Missing certificate basic contraints',
        invalid_key_usage: 'Invalid certificate key usage'
    },
    ssl_verify_hostname: {
        unable_to_match_altnames: 'Certificate hostname mismatch',
        unable_to_match_common_name: 'Certificate hostname mismatch',
        unable_to_decode_common_name: 'Invalid certificate hostname'
    }
};

var POST_ERRORS = {
    connection_down: function (message, response) {
        return "Connection offline, your " + (message ? 'message' : 'request') + " wasn’t sent";
    },
    connection_unavailable: function (message, response) {
        return "Connection temporarily unavailable, your " + (message ? 'message' : 'request') + " wasn’t sent. Try again later";
    },
    database_down: "Service unavailable. Try again later.",
    auth: "Forbidden",
    invalid_org_id: "Invalid team ID",
    invalid_cid: "Invalid connection ID",
    invalid_nick: "Invalid nickname",
    invalid_edit: "Message edits can't be blank",
    paste_too_large: "Sorry, you can’t paste more than 50 KB of text.",
    paste_invalid: "Sorry, you need to paste valid UTF8.",
    paste_empty: "No empty pastes allowed",
    file_too_large: function (message, response) {
        var size = '';
        var fileSize = response.size || response.content_length;
        if (fileSize) {
            size = ' (upload is ' + FileWrapper.sizeToString(fileSize) + ')';
        }
        return "Sorry, you can’t upload files larger than 15 MB." + size;
    },
    invalid_file_type: "Sorry, you need to upload a valid file",
    image_too_large: "Sorry, you can’t upload images larger than 25 Megapixels",
    file_write_error: "Failed to upload a file",
    banned_content: "Banned content",
    upload_limit_reached: "Sorry, you can’t upload more than 100 MB of files",
    unverified: "Email verification required",
    missing_file: "No file uploaded",
    upload_already_exists: "You’ve already uploaded this file",
    invalid_upload_id: "Invalid upload ID",
    upload_not_found: "Upload not found",
    upload_error: "Failed to upload a file",
    batch_upload_failed: "Failed to upload files",
    blocked_command: "This command has been blocked",
    invalid_topic: "Invalid topic"
};

function renderReason (reason) {
    return RENDER_REASONS[reason] || reason;
}

function renderSSLVerify (info) {
    if (info) {
        var type = SSL_VERIFY_ERRORS[info.type];
        if (type) {
            var error = type[info.error];
            if (error) {
                return error;
            }
        }
        return info.type + ': ' + info.error;
    }
}

function renderRestrictedReason (reason) {
    var defaultReason = 'You can’t connect to this server with a free account. <b>Upgrade now</b>';
    return RESTRICTED_REASONS[reason] || defaultReason;
}

function renderRestrictedReasonShort (reason) {
    var defaultReason = 'Limited';
    return RESTRICTED_REASONS_SHORT[reason] || defaultReason;
}

function renderPostError (response, message) {
    response = response || {};
    var defaultError = message ? "We failed to send your message" : "Your request failed";
    if (_.isFunction(POST_ERRORS[response.message])) {
        return POST_ERRORS[response.message](message, response);
    } else {
        return POST_ERRORS[response.message] || (defaultError + ': ' + response.message);
    }
}

module.exports = {
    render: renderReason,
    renderRestricted: renderRestrictedReason,
    renderRestrictedShort: renderRestrictedReasonShort,
    renderPostError: renderPostError,
    renderSSLVerify: renderSSLVerify
};



//////////////////
// WEBPACK FOOTER
// ./app/src/view/renderreasons.js
// module id = ilaq
// module chunks = 1